import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import { BoldLabel } from 'components/labels';
import { Text } from 'components/Text';

export const SummaryCard = styled(Card)(() => ({
  borderRadius: 16,
  marginBottom: 32,
  marginTop: 80
}));

export const SummaryCardHeader = styled(Box)(({ theme }) => ({
  height: 114,
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  padding: theme.spacing(1),
  backgroundImage: "url('/assets/card_header_background.png')",
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  '& > h4': {
    color: theme.palette.common.white,
    fontWeight: 700,
    textTransform: 'uppercase',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
}));

export const SummaryCardContent = styled(Box)(({ theme }) => ({
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),
  paddingBottom: theme.spacing(1.5),
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(0, 4, 2.5)
  },
  '& > div': {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      paddingTop: theme.spacing(1.5),
      paddingBottom: theme.spacing(1.5)
    }
  },
  '& > div:first-of-type': {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(0)
  }
}));

export const AutoCloseLabel = styled(Text)(({ theme }) => ({
  color: theme.palette.text.disabled,
  fontWeight: 500
}));

export const ButtonsWrapper = styled(Box)(({ theme }) => ({
  '& > button': {
    marginLeft: '5%',
    [theme.breakpoints.up('sm')]: {
      maxWidth: '100%'
    },
    '@media (max-width: 349px)': {
      marginLeft: '2.5%'
    }
  },
  '& > button:first-of-type': {
    marginLeft: 0
  }
}));

export const ReasonCardWrapper = styled(Card)(({ theme }) => ({
  alignItems: 'center',
  minHeight: theme.spacing(10),
  borderRadius: 0,
  cursor: 'pointer',
  margin: theme.spacing(1, -1.5, -1),
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(-4),
    marginRight: theme.spacing(-4),
    marginBottom: theme.spacing(-1)
  }
}));

export const ReasonCardContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: 12,
  [theme.breakpoints.up('sm')]: {
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4)
  }
}));

export const ReasonTypeText = styled(BoldLabel)(({ theme }) => ({
  whiteSpace: 'normal',
  padding: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: 14
  }
}));

export const ReasonInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  minWidth: 90,
  marginLeft: theme.spacing(1),
  [theme.breakpoints.up('sm')]: {
    marginLeft: 2
  }
}));

export const ReasonInfoLabel = styled(BoldLabel)(({ theme }) => ({
  padding: 0,
  [theme.breakpoints.down('sm')]: {
    fontSize: 13
  }
}));
